import Swal from "sweetalert2";

const alert = (title, message, type) => Swal.fire(title, message, type);

const confirmDialog = (title, message) =>
  Swal.fire({
    title: title,
    text: message,
    type: "question",
    showCancelButton: true,
    confirmButtonColor: "var(--vs-azul-primaria)",
    cancelButtonColor: "var(--vs-vermelho)",
    confirmButtonText: "Sim",
    cancelButtonText: "Não",
    reverseButtons: true,
    buttonsStyling: true
  });

export default {
  success: (title, message) => alert(title, message, "success"),
  error: (title, message) => alert(title, message, "error"),
  warn: (title, message) => alert(title, message, "warning"),
  info: (title, message) => alert(title, message, "info"),
  confirm: confirmDialog
};
